const config = new Map();

export default config;